module.exports = __webpack_public_path__ + "static/media/oil-temperature.8438228e.svg";